const articleSummary = () => {
  const summary = new Component({
    component: document.querySelectorAll(`.article_summary`),
    callback: (component) => {
      const title = component.getAttribute('data-title');
  
      headingId(component, 'h2');
      headingId(component, 'h3');
      headingId(component, 'h4');
      headingId(component, 'h5');
      headingId(component, 'h6');
      
      if (title) {
        new Element({
          type: 'h2',
          id: slugify(title),
          classes: [
            'heading--sm',
          ],
          attributes: [
            ['data-anchor', 'heading'],
          ],
          content: title,
          append: {
            parent: component,
            before: component.childNodes[0]
          }
        })
      }
    },
  });
}

articleSummary();